import { render, staticRenderFns } from "./StripePayment.vue?vue&type=template&id=c2f0b43a&scoped=true"
import script from "./StripePayment.vue?vue&type=script&lang=js"
export * from "./StripePayment.vue?vue&type=script&lang=js"
import style0 from "./StripePayment.vue?vue&type=style&index=0&id=c2f0b43a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f0b43a",
  null
  
)

export default component.exports